export const generateSequentialNumberOptions = (maximum: number) => {
  const temp = new Array<number>(maximum).fill(undefined);

  return temp.map((_, index) => ({ label: index + 1, value: index + 1 }));
};
